import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

// Max 3 decimals everywhere; auto-compact to millions for large values.
// Examples:
//   14110239     -> "14.11M"
//   1000000      -> "1M"
//   987654.321   -> "987,654.321"
//   1234.5       -> "1,234.5"
//   12           -> "12"
const _trimDec = (s) => s.replace(/\.?0+$/, "");

export const fmtNumber = (n) => {
  if (n == null || isNaN(n)) return "—";
  const x = Number(n);
  const abs = Math.abs(x);
  if (abs >= 1_000_000) {
    const m = x / 1_000_000;
    return `${_trimDec(m.toFixed(3))}M`;
  }
  const parts = x.toFixed(3).split(".");
  const intStr = new Intl.NumberFormat("en-US").format(Number(parts[0]));
  const dec = _trimDec(`.${parts[1] || "0"}`).replace(/^\./, "");
  return dec ? `${intStr}.${dec}` : intStr;
};

export const fmtCurrency = (n, currency = "KWD") => {
  if (n == null || isNaN(n)) return "—";
  return `${fmtNumber(n)} ${currency}`;
};

export const fmtPct = (n, digits = 1) => {
  if (n == null || isNaN(n)) return "—";
  const d = Math.min(3, Math.max(0, digits));
  return `${_trimDec(Number(n).toFixed(d))}%`;
};
